// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2pg9Q","content":"RecentSearches_content__1Oy2d"};